import { useCallback } from 'react';

import * as helpers from '../helpers';
import { useGetFormFieldValue } from '../../../hooks';
import { useComponentTranslations } from 'js/hooks/component';
import { useUpdateFieldValue } from '../../ChangeFormField/hooks';

export const useSpanishIDFieldValidation = (name: string) => {
    const DNI_LENGTH = 9;
    const getFormFieldValue = useGetFormFieldValue();
    const translate = useComponentTranslations();
    const updateFieldValue = useUpdateFieldValue({ fieldName: name });

    return useCallback((value = '', formValues): string | undefined => {
        const countryCode = getFormFieldValue('countrycode', formValues);
        const citizenship = getFormFieldValue('citizenship', formValues);

        if (!(countryCode && citizenship)) {
            return translate('playtech.mobile.system.user.tooltip.spanishID.emptyCountryOrNational');
        }

        if (citizenship !== 'ES' && countryCode !== 'ES') {
            return;
        }

        if (citizenship === 'ES' && countryCode !== 'ES' && !value.length) {
            return;
        }

        if (citizenship === 'ES' && countryCode === 'ES' && !value.length) {
            return translate('playtech.mobile.system.user.tooltip.spanishID.required');
        }

        if (citizenship === 'ES' && value.length) {
            if (!helpers.checkDNI(value)) {
                return translate('playtech.mobile.system.user.tooltip.spanishID.wrong', ['DNI']);
            }

            value.length < DNI_LENGTH && updateFieldValue(String(`00000000${value}`).slice(-DNI_LENGTH));
        }

        if (citizenship !== 'ES' && countryCode === 'ES' && !value.length) {
            return translate('playtech.mobile.system.user.tooltip.spanishID.required');
        }

        if (citizenship !== 'ES' && countryCode === 'ES' && value.length && !helpers.checkNIE(value)) {
            return translate('playtech.mobile.system.user.tooltip.spanishID.wrong', ['NIE']);
        }

    }, [getFormFieldValue, translate, updateFieldValue]);
};
